<template>
  <b-modal
    class="mc-modal"
    id="mc-modal-order"
    ref="mc-modal-order"
    :title="title"
    size="xl"
    centered
    >
    <div>
      <b-container fluid>
        <McTable
          ref="doTable"
          :fields="fields"
          :apiClient="apiClient"
          withCard
          searchable
          stickyHeader
          class="mc-order-table"
          :hasDelete="false"
          :hasCheckbox="false"
          :customHandlers="{ isItemSelectDisabled }"
          :hasSelectableRow="true"
          @handleSelectValue="handleSelectValue"
          @listRes="setList"
        >
          <template #before-table>
            <McAlert variant="info" withIcon :text="$t('invoice.warningMessage.pleaseSelectRelation')" />
          </template>
          <template #cell()="{ field, value, item }">
            <div :class="item.transaction_number ? 'lightgray' : ''">
              <a v-if="field.key === 'attachment.name'" class="image-url" :href="item.attachment.url" target="_blank">{{ value }}</a>  
              <span v-else-if="field.key === 'transaction_number'">{{ value !== '' ? value : '' }}</span>
              <div v-else>
                {{ value }}
              </div>
            </div>
          </template>

          <!-- Special slot for first column, can't put on general #cell() slot -->
          <template #cell(transaction_date)="{ value, item }">
            <div :class="item.transaction_number ? 'lightgray' : ''">
              <div>{{ formatIndexDate(value).date }}</div>
              <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
            </div>
          </template>

        </McTable>
      </b-container>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel"
        />
        <McButton
          variant="primary"
          :text="$t('global.action.apply')"
          :disabled="applyBtnDisabled"
          @click="submit(cancel)"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McTable from '@/components/McTable'
import McAlert from '@/components/McAlert'
import { formatIndexDate } from '@/helpers/tzDate'
import fields from './lib/fields'
import isEmpty from 'lodash/isEmpty'

import moment from 'moment'
moment.locale('id')

export default {
  components: {
    McButton,
    McTable,
    McAlert
  },
  mixins: [fields],
  props: {
    taskNumber: {
      type: String
    },
    activityId: {
      type: String
    }
  },
  data() {
    return {
      selected: [],
      listLoading: false,
      detailLoading: false,
      items: [],
      selectedIds: {}
    }
  },
  computed: {
    title() {
      return this.$t('invoice.modal.title.selectCostRelation')
    },
    applyBtnDisabled() {
      return this.selected.length === 0
    },
    apiClient() {
      let getData = ({ limit, page, search }) =>  {
        const data = this.$store.state.invoice.selectedDos
        const total = data.length
        const result = this.paginate(data, limit, page, search)
        return {
          data:{
            paginated_result: result
          },
          metadata: {
            count: result.length,
            page,
            total_count: total,
            total_page: Math.ceil(total/limit)
          }
        }
      }
      return {
        get: getData,
      }
    },
  },
  methods: {
    formatIndexDate,
    submit(closeCallback) {
      const selectedItems = []
      this.selected.forEach(id => {
        const order = this.items.find(v => v.id === id)
        selectedItems.push({
          id,
          number: order.number
        })
      })
      this.$emit('submit', selectedItems)

      closeCallback()
    },
    handleSelectValue(ids) {
      this.selected = Object.keys(ids)
        .filter((key) => ids[key] === true)
        .map((id) => id)

      // Reset when unselect all checkbox 
      if (isEmpty(ids)) {
        this.selectedIds = ids
      }
    },
    setList(res) {
      this.items = res.data.paginated_result
    },
    isItemSelectDisabled(item) {
      return !!item.transaction_number
    },
    handleSelect(checked, item) {
      this.selectedIds = { ...this.selectedIds, [item.id]: checked }
      if (checked) {
        this.$refs['doTable'].selectedIdsLength += 1
      } else {
        this.$refs['doTable'].selectedIdsLength -= 1
      }
      this.handleSelectValue(this.selectedIds)
    },
    isDisableRowCheckbox(item) {
      return this.selectedIds[item.id] ? false : this.isItemSelectDisabled(item)
    },
    // TODO will be used for next development
    /**
     * - add event @shown="onModalShown" on the b-modal component
     * - add prop :checked="selectedIds[item.id] || !!item.transaction_number" on the b-form-checkbox component 
     *   inside <template #cell(checkbox)="{ item }">
     */
    onModalShown() {
      if (!isEmpty(this.selectedIds)) {
        this.$refs['doTable'].selectedIdsLength = Object.keys(this.selectedIds).length
      }
    },
    paginate(data, limit, page, search = null) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      let finalData = data
      if (search) {
        const regex = new RegExp(search, "i")
        finalData = data.filter(v => v.number.search(regex) !== -1)
      }
      return finalData.slice((page - 1) * limit, page * limit)
    }
  },
}
</script>

<style lang="scss">
@import './style.scss';
</style>
